"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _emotion = require("emotion");

require("../../assets/vendor/react-select.min.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: #fff;\n  cursor: pointer;\n  font-size: 15px;\n  margin: 10px;\n  z-index: 1404 !important;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var dropdownClass = (0, _emotion.css)(_templateObject());

var Dropdown = function Dropdown(_ref) {
  var options = _ref.options,
      onChange = _ref.onChange,
      value = _ref.value,
      clearable = _ref.clearable,
      searchable = _ref.searchable,
      disabled = _ref.disabled,
      simpleValue = _ref.simpleValue,
      multi = _ref.multi,
      placeholder = _ref.placeholder;
  return _react["default"].createElement(_reactSelect["default"], {
    className: dropdownClass,
    options: options,
    onChange: onChange,
    value: value,
    clearable: clearable,
    searchable: searchable,
    disabled: disabled,
    simpleValue: simpleValue,
    multi: multi,
    placeholder: placeholder
  });
};

Dropdown.displayName = "Dropdown";
Dropdown.propTypes = {
  onChange: _propTypes["default"].func.isRequired,
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].string,
    label: _propTypes["default"].string
  })).isRequired,
  value: _propTypes["default"].any,
  clearable: _propTypes["default"].bool,
  searchable: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  simpleValue: _propTypes["default"].bool,
  multi: _propTypes["default"].bool,
  placeholder: _propTypes["default"].string
};
Dropdown.defaultProps = {
  clearable: false,
  searchable: true,
  disabled: false
};
var _default = Dropdown;
exports["default"] = _default;